import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { teamsAPI } from '../api/api';
import { gmDisplayName } from '../utils/displayName';

const Teams = () => {
  const [teams, setTeams] = useState({ eastern: [], western: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    try {
      const response = await teamsAPI.getAll();
      const allTeams = response.data;
      
      const eastern = allTeams.filter(t => t.conference === 'Eastern');
      const western = allTeams.filter(t => t.conference === 'Western');
      
      setTeams({ eastern, western });
    } catch (error) {
      console.error('Error loading teams:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderTeamGrid = (teamList, conferenceName) => {
    return (
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">{conferenceName} Conference</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {teamList.map((team) => {
            const logoFile = team.name.toLowerCase().replace(/\s/g, '') + '.svg';
            return (
              <Link
                key={team.id}
                to={`/teams/${team.id}`}
                className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-6 hover:shadow-xl transition transform hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-4 flex-1">
                    <img 
                      src={`/images/teams/${logoFile}`}
                      alt={`${team.name} logo`}
                      className="w-16 h-16 object-contain"
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                    <div>
                      <h3 className="text-xl font-bold">{team.city}</h3>
                      <h4 className="text-lg text-gray-600 dark:text-gray-400">{team.name}</h4>
                    </div>
                  </div>
                  <div 
                    className="text-3xl font-bold opacity-50"
                    style={{ color: team.primaryColor || '#1d428a' }}
                  >
                    {team.abbreviation}
                  </div>
                </div>
                {/* Owner Information */}
                {team.owner && (
                  <div className="mb-3 pb-3 border-b border-gray-200 dark:border-gray-700">
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-gray-500 dark:text-gray-400">Owner:</span>
                      <span className="font-semibold text-gray-700 dark:text-gray-300">{gmDisplayName(team.owner)}</span>
                      {team.owner.platform && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                          {team.owner.platform === 'Xbox' ? '🎮' : '🎯'} {team.owner.platform}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600 dark:text-gray-400">{team.conference}</span>
                  <span className="text-nba-blue hover:underline font-semibold">
                    View Roster →
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-2xl text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8">All Teams</h1>
      {renderTeamGrid(teams.eastern, 'Eastern')}
      {renderTeamGrid(teams.western, 'Western')}
    </div>
  );
}

export default Teams;
